import { v4 as uuidv4 } from 'uuid'

export const createChatMessage = (message, type = 'bot', options = {}) => ({
  message,
  type,
  id: uuidv4(),
  ...options,
})

export const createChatBotMessage = (message, options = {}) =>
  createChatMessage(message, 'bot', { ...options })

export const createCustomMessage = (message, type, options = {}) =>
  createChatMessage(message, type, options)